export const contratacaoSituacoes = {
    CADASTRADA: 0,
    AGUARDANDO_APROVACAO: 1,
    AGUARDANDO_ANALISE_DO_RODIZIO: 2,
    EM_AJUSTE_PELA_UNIDADE_DEMANDANTE: 3,
    APROVADA: 4,
    AGUARDANDO_ACEITE: 5,
    AGUARDANDO_AUTORIZACAO_DE_OUTRA_UF: 6,
    AGUARDANDO_EMISSAO_DO_CONTRATO: 7,
    AGUARDANDO_INICIO_DA_CONTRATACAO: 8,
    EM_ANDAMENTO: 9,
    EM_ANDAMENTO_COM_ADITIVO: 10,
    CONCLUIDA_SEM_AVALIACAO: 11,
    CONCLUIDA_SEM_AVALIACAO_COM_ADITIVO: 12,
    DISTRATO: 13,
    CANCELADA: 14,
    EM_AJUSTE_DE_CONTRATACAO_APROVADA: 15,
    CONCLUIDA_COM_AVALIACAO: 16,
    CONCLUIDA_COM_AVALIACAO_COM_ADITIVO: 17
}